module.exports = __webpack_public_path__ + "img/2021091514503441.924b4765.png";